import { INVOICE_STATUS_LABELS, type InvoiceStatus } from "@shared/modules/x-atelier";
import { Badge } from "../../../core/components/ui/badge";
import type { BadgeVariant } from "../lib/status";

/** Couleurs de statut d'une facture : tokens seulement, via les pastilles du noyau. */
export const INVOICE_STATUS_VARIANT: Record<InvoiceStatus, BadgeVariant> = {
  en_attente: "warning",
  en_souffrance: "danger",
  payee: "success",
  annulee: "neutral",
};

export function InvoiceStatusBadge({
  status,
  overdueDays = 0,
}: {
  status: InvoiceStatus;
  overdueDays?: number;
}) {
  return (
    <Badge variant={INVOICE_STATUS_VARIANT[status]}>
      {INVOICE_STATUS_LABELS[status]}
      {status === "en_souffrance" && overdueDays > 0 ? ` · ${overdueDays} j` : ""}
    </Badge>
  );
}
